export const GA_QUOTA_EXHAUSTED_TYPE = "https://api-docs.similarweb.com/error/quota-exhausted";

export type GaErrorKind = "access-denied" | "dependency-failed" | "rate-limited" | "quota-exhausted" | "unknown";

export const classifyGaError = (status: number, problemType?: string): GaErrorKind => {
    switch (status) {
        case 403:
            return "access-denied";
        case 424:
            return "dependency-failed";
        case 429:
            if (problemType === GA_QUOTA_EXHAUSTED_TYPE) {
                return "quota-exhausted";
            }
            return "rate-limited";
        default:
            return "unknown";
    }
};
